<template>
    <!-- <ul class="navbar-nav">
        <li class="nav-item" v-for="category in categories" :key="category.index">
            <a :href="categoryPageUrl + '/category/' + category.id" class="nav-link" v-if="category.parent_id == '0'">{{ category.name }} </a>
        </li>
    </ul> -->
    <div class="d-flex align-items-center">
        <div class="navbar-nav" v-for="category in categories" :key="category.index">
            <a :href="categoryPageUrl + '/category/' + category.id" class="nav-link">
                {{ category.name }}
            </a>
            <div class="navbar-nested" v-if="category.children.length">
                <div v-for="nested in category.children" :key="nested.index">
                    <a :href="categoryPageUrl + '/category/' + nested.id">
                        {{ nested.name }}
                    </a>
                    <div class="nested-child" v-for="nestedChild in nested.children" :key="nestedChild.index">
                        <a :href="categoryPageUrl + '/category/' + nestedChild.id">
                            {{ nestedChild.name }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import categoriesMixin from "@/v2/mixins/product-categories.js";

export default {
    mixins: [categoriesMixin],
    props: {
        categoryUrl: {
            type: String,
        },
        categoryPageUrl: {
            type: String,
        },
    },
    data() {
        return {
            categories: null,
            categoryPagination: null,
        };
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        loadCategories(payload, success, failure) {
            this.categories = [];

            this.getProductCategories(this.categoryUrl, payload, (categories, pagination) => {
                categories.forEach((category) => {
                    if (category.parent_id == 0) {
                        this.categories.push(category);
                    }
                });
                if (success) success(this.categories);
            });
        },
        fetchCategories(payload = null, success = null, failure = null) {
            this.loadCategories(payload, success, failure);
        },
    },
};
</script>
